import tmhRequest from '@/config/tmhRequest'

export default {
    createSettlementOrderDetail: function (data) {
        return tmhRequest({
            url: '/finance/tmh/settlementorderdetail/createsettlementorderdetail',
            method: 'post',
            params: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/finance/settlementorderdetail.js